import { BASE_FONT_SIZE } from '../constants';

export const toRem = (fontSize: number = BASE_FONT_SIZE): string => `${fontSize / BASE_FONT_SIZE}rem`;
